import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#009fa6", //"#1D6D7D",
        secondary: "#f4605c", //"#4AA399",
        third: "#226174"
      },
      dark: {
        primary: "#009fa6", //"#1D6D7D",
        secondary: "#f4605c", //"#4AA399",
        third: "#226174"
      }
    }
  }
});
